export const openLiveChat = () => window?.fcWidget?.open();
